import { Quote, Shell, CustomerArea, Offline } from './scenes';
import * as React from 'react';
import steps from './scenes/Quote/steps';
import { IBrandingState } from './services/branding/models';
import { ICustomer } from './data/api/models';
import { Route, Switch } from 'react-router';
import CookiePolicyContainer from './scenes/Brochure/scenes/CookiePolicyContainer';

interface IAppProps {
  branding: IBrandingState;
  customer?: ICustomer;
}

export default ({ branding, customer }: IAppProps) => {
  const quoteSteps = steps(branding.channel);
  const customerArea = <CustomerArea key={1} steps={quoteSteps} channel={branding.channel} />;
  const cookiePolicyContainer = <CookiePolicyContainer />;
  const quote = <Quote key={2} steps={quoteSteps} channel={branding.channel} customer={customer} />;
  const pageTitles = {
    '/auth/login': 'Customer Account',
    '/auth/remind': 'Forgot your password',
    '/auth/create-an-account': 'Create your personal space',
  };
  const routes = (
    <Switch>
      <Route path="/cookies">{cookiePolicyContainer}</Route>

      <Route path="/auth">{customerArea}</Route>
      <Route path="/account">{customerArea}</Route>
      <Route path="/password">{customerArea}</Route>
      <Route>{quote}</Route>
    </Switch>
  );

  return (
    <Shell pageTitles={pageTitles} steps={quoteSteps} channel={branding.channel}>
      {branding.isOffline ? <Offline /> : routes}
    </Shell>
  );
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/index.tsx